import React, { useState } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { InputGroup, FormControl } from "react-bootstrap";

// eslint-disable-next-line object-curly-newline
function TimePicker({ getSelectedTime, label, placeHolderTime, date }) {
  const timeHours = placeHolderTime
    ? moment(placeHolderTime).format("h:mm a")
    : moment().format("h:mm a");
  const [isValidTimeFormat, setIsValidTimeFormat] = useState(false);
  const [currentTime, setCurrentTime] = useState(null);
  const validateTime = (e) => {
    const time = e.target.value;
    if (time === "") {
      setCurrentTime(null);
    } else {
      setCurrentTime(time);
    }
    const regexPattern = /^(1[0-2]|0?[1-9]):[0-5][0-9] (AM|PM|am|pm)$/;
    if (!regexPattern.test(time)) {
      setIsValidTimeFormat(false);
      getSelectedTime(null);
    } else {
      setIsValidTimeFormat(true);
      let formattedDate = null;
      if (date) {
        formattedDate = moment(date + time, "YYYY-MM-DD h:mm a").toISOString();
      } else {
        formattedDate = moment(time, "h:mm a").toISOString();
      }
      getSelectedTime(formattedDate);
    }
  };
  return (
    <InputGroup className="mb-3">
      <FormControl
        placeholder={timeHours}
        aria-label={label}
        aria-describedby="basic-addon1"
        onChange={(e) => validateTime(e)}
        isValid={isValidTimeFormat}
        isInvalid={!isValidTimeFormat && currentTime}
      />
    </InputGroup>
  );
}

TimePicker.propTypes = {
  getSelectedTime: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  time: PropTypes.instanceOf(Object),
  warning: PropTypes.string.isRequired,
};

export default TimePicker;
